import {pxToRem} from '../../../../utills/pxToRem'
import {fonts} from '../../../../theme/foundations/fonts'
import sizes from '../../../../theme/foundations/sizes'

const {md} = sizes.container

export const promoTilesContainer = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [`@media (min-width: ${md})`]: {
        flexDirection: 'row',
        gap: pxToRem(25)
    },
    '.promotional-tile': {
        position: 'relative',
        img: {
            width: '100%',
            marginBottom: pxToRem(10)
        },
        '.promotional-inner-overlay': {
            position: 'absolute',
            top: pxToRem(15),
            left: pxToRem(13),
            [`@media (min-width: ${md})`]: {
                top: pxToRem(34),
                left: pxToRem(34)
            }
        },
        '.cta-button': {
            position: 'absolute',
            bottom: pxToRem(16),
            right: pxToRem(15),
            color: '#FFF',
            textAlign: 'center',
            fontFamily: fonts.primary,
            fontSize: pxToRem(12),
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: pxToRem(13.5),
            letterSpacing: pxToRem(1.44),
            textTransform: 'uppercase',
            padding: `0 ${pxToRem(10)}`,
            _hover: {
                textDecoration: 'underline'
            },
            [`@media (min-width: ${md})`]: {
                bottom: pxToRem(23),
                right: 0,
                fontSize: pxToRem(14),
                letterSpacing: pxToRem(1.68),
                padding: `${pxToRem(13)} ${pxToRem(78)}`
            }
        }
    }
}
